/* Modecraze facets behaviour. Loads after facets.js (both defer). facets.js is not modified. */
(function () {
  'use strict';

  function focusSearch(scope) {
    var input = scope && scope.querySelector('.mc-search__input');
    if (!input) return;
    requestAnimationFrame(function () { input.focus({ preventScroll: true }); });
  }

  // Mobile: forget the chosen letter when the accordion or the sheet closes.
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d.tagName !== 'DETAILS') return;
    var isBrandAcc = d.classList.contains('mc-acc') && d.classList.contains('mc-facet--brand');
    // no auto-focus on mobile: the raised keyboard swallows the next tap
    if ((isBrandAcc || d.classList.contains('mc-sheet-details')) && !d.open) {
      d.querySelectorAll('.mc-facet--brand').forEach(resetBrand);
      if (isBrandAcc) resetBrand(d);
    }
  }, true);

  /* ---- Brand facet: letters, search, popular chips (desktop) ---------------- */
  var currentLetter = {};   // scope id -> letter, survives facets.js re-renders

  function setHeading(scope, text) {
    var h = scope.querySelector('[data-mc-heading]');
    if (h) h.textContent = text;
  }

  function showLetter(scope, letter) {
    currentLetter[scope.id] = letter;
    scope.setAttribute('data-mc-view', 'letter');
    scope.querySelectorAll('.mc-item').forEach(function (li) {
      li.hidden = li.dataset.letter !== letter;
    });
    scope.querySelectorAll('[data-mc-letter]').forEach(function (b) {
      b.classList.toggle('is-current', b.dataset.mcLetter === letter);
    });
    var h = scope.querySelector('[data-mc-heading]');
    setHeading(scope, h ? (h.dataset.mcPrefix + ' ' + letter) : '');
    var list = scope.querySelector('.mc-list--brand');
    if (list) list.scrollTop = 0;
  }

  function showSearch(scope, q) {
    scope.setAttribute('data-mc-view', 'search');
    var lower = q.toLowerCase(), n = 0;
    scope.querySelectorAll('.mc-item').forEach(function (li) {
      var hit = li.textContent.toLowerCase().indexOf(lower) !== -1;
      li.hidden = !hit;
      if (hit) n++;
    });
    scope.querySelectorAll('[data-mc-letter]').forEach(function (b) { b.classList.remove('is-current'); });
    setHeading(scope, n ? 'Results for \u201c' + q + '\u201d' : 'No results for \u201c' + q + '\u201d');
  }

  function hideAll(scope) {
    scope.removeAttribute('data-mc-view');
    scope.querySelectorAll('.mc-item').forEach(function (li) { li.hidden = true; });
    scope.querySelectorAll('[data-mc-letter]').forEach(function (b) { b.classList.remove('is-current'); });
    setHeading(scope, '');
  }

  function resetBrand(scope) {
    delete currentLetter[scope.id];
    var search = scope.querySelector('.mc-search__input');
    if (search) search.value = '';
    hideAll(scope);
  }

  // Nothing listed until a letter is chosen; the letter is kept only while the facet stays open.
  function initBrand(scope) {
    if (!scope.querySelector('.mc-az')) return;
    var letter = currentLetter[scope.id];
    if (letter && scope.querySelector('[data-mc-letter="' + letter + '"]')) showLetter(scope, letter);
    else hideAll(scope);
  }

  document.querySelectorAll('.mc-facet--brand').forEach(initBrand);

  // facets.js replaces facet innerHTML after most filter changes: re-apply state.
  // facets.js re-renders a facet by replacing its innerHTML, i.e. the direct
  // children of the .mc-facet--brand element. Watch for exactly that.
  ['FacetsDesktop', 'FacetsMobile'].forEach(function (id) {
    var root = document.getElementById(id);
    if (!root) return;
    new MutationObserver(function (muts) {
      var seen = [];
      muts.forEach(function (m) {
        var t = m.target;
        if (t.nodeType !== 1 || !t.classList.contains('mc-facet--brand') || seen.indexOf(t) !== -1) return;
        seen.push(t);
        initBrand(t);
      });
    }).observe(root, { childList: true, subtree: true });
  });

  document.addEventListener('click', function (e) {
    var letter = e.target.closest('[data-mc-letter]');
    if (letter) {
      e.preventDefault();
      var scope = letter.closest('.js-filter');
      var search = scope.querySelector('.mc-search__input');
      if (search) search.value = '';
      showLetter(scope, letter.dataset.mcLetter);
      return;
    }
    var pick = e.target.closest('[data-mc-pick]');
    if (pick) {
      e.preventDefault();
      var scope2 = pick.closest('.js-filter');
      var input = null;
      scope2.querySelectorAll('.mc-option input').forEach(function (i) { if (i.value === pick.dataset.mcPick) input = i; });
      if (!input) return;
      input.click();                                       // fires the form "input" event facets.js listens for
      pick.classList.toggle('is-active', input.checked);
    }
  });

  // Search (desktop + mobile). Capture phase so keystrokes never reach the
  // form "input" listener in facets.js, which would trigger a reload per key.
  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!input.classList || !input.classList.contains('mc-search__input')) return;
    e.stopPropagation();
    var scope = input.closest('.js-filter');
    if (!scope) return;
    var q = input.value.trim();
    if (q === '') {
      if (scope.querySelector('.mc-az')) initBrand(scope);
      else scope.querySelectorAll('.mc-item').forEach(function (li) { li.hidden = false; });
      return;
    }
    showSearch(scope, q);
  }, true);

  /* ---- Mobile: Apply closes the sheet and returns to the grid --------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-mc-sheet-close]');
    if (!btn) return;
    var details = btn.closest('details');
    if (!details) return;
    var summary = details.querySelector('summary');
    if (summary) summary.click(); else details.removeAttribute('open');
    var grid = document.getElementById('ProductGridContainer');
    if (grid) setTimeout(function () { grid.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 350);
  });

  /* ---- Desktop band ---------------------------------------------------------- */
  var details = document.getElementById('FacetDrawer');
  if (!details || details.tagName !== 'DETAILS') return;

  var summary = details.querySelector('summary');
  var band = details.querySelector('.mc-band');
  if (!summary || !band) return;

  function setActive(index) {
    details.dataset.activeIndex = index;
    summary.querySelectorAll('[data-facet-tab]').forEach(function (tab) {
      tab.classList.toggle('is-active', tab.dataset.facetTab === index);
    });
    if (details.open) focusSearch(details.querySelector('.mc-facet--brand[data-index="' + index + '"]'));
  }
  details.addEventListener('toggle', function () {
    if (details.open) focusSearch(details.querySelector('.mc-facet--brand[data-index="' + details.dataset.activeIndex + '"]'));
    else details.querySelectorAll('.mc-facet--brand').forEach(resetBrand);
  });

  var first = summary.querySelector('[data-facet-tab]');
  if (first) setActive(first.dataset.facetTab);

  // Tab click: open on that facet; switching tabs while open keeps the band open;
  // clicking the active tab again closes it (native <details> toggle).
  summary.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-facet-tab]');
    if (!tab) { e.preventDefault(); return; }               // clicks on summary padding do nothing
    var index = tab.dataset.facetTab;
    if (details.open && details.dataset.activeIndex !== index) {
      e.preventDefault();
      setActive(index);
      return;
    }
    setActive(index);
  });

  // facets.js re-renders .facets__open (the tab strip) after every filter change.
  new MutationObserver(function () {
    if (details.dataset.activeIndex) setActive(details.dataset.activeIndex);
  }).observe(summary, { childList: true, subtree: true });

  // Close when the page has scrolled to the point where the filter bar pins
  // (sticky facets) or would leave the top of the screen (non-sticky).
  // Uses document positions, so it works whether or not the bar is sticky.
  var barDocTop = 0;
  function pinnedOffset() {
    var sticky = details.closest('.facet-filters-sticky');
    if (!sticky) return 0;
    var t = parseFloat(getComputedStyle(sticky).top);
    return isNaN(t) ? 0 : t;
  }
  details.addEventListener('toggle', function () {
    if (!details.open) return;
    // natural (unpinned) position: current position minus how far it is pinned above natural
    var rectTop = summary.getBoundingClientRect().top;
    var sticky = details.closest('.facet-filters-sticky');
    var stuck = sticky && sticky.classList.contains('shopify-section-filters-sticky');
    barDocTop = stuck ? window.scrollY + pinnedOffset() : rectTop + window.scrollY;
  });
  // Collapse with the normal transition while scrolling the page by the band's
  // shrinking height each frame, so the products stay put under the cursor.
  var collapsing = false;
  function collapseAnchored() {
    if (collapsing) return;
    collapsing = true;
    var prev = band.getBoundingClientRect().height;
    details.removeAttribute('open');
    function step() {
      var h = band.getBoundingClientRect().height;
      var d = h - prev;
      if (d) window.scrollBy(0, d);
      prev = h;
      if (h > 0.5) requestAnimationFrame(step); else collapsing = false;
    }
    requestAnimationFrame(step);
  }

  var scrollTicking = false;
  document.addEventListener('scroll', function (e) {
    if (!details.open || e.target !== document || scrollTicking || collapsing) return;
    scrollTicking = true;
    requestAnimationFrame(function () {
      scrollTicking = false;
      if (!details.open || collapsing) return;
      if (window.scrollY < barDocTop - pinnedOffset()) return;
      collapseAnchored();
    });
  }, true);

  // Close button in the footer
  details.addEventListener('click', function (e) {
    if (e.target.closest('[data-mc-close]')) details.removeAttribute('open');
  });

  // Keep the under-bar selected row in sync with the band's chips
  // (facets.js only re-renders the first .active-facets-desktop).
  var chipsSrc = details.querySelector('.active-facets-desktop');
  var chipsMirror = document.querySelector('[data-mc-selected]');
  if (chipsSrc && chipsMirror) {
    new MutationObserver(function () { chipsMirror.innerHTML = chipsSrc.innerHTML; })
      .observe(chipsSrc, { childList: true, subtree: true });
  }

  // Close on outside click and Escape
  document.addEventListener('click', function (e) {
    if (details.open && !details.contains(e.target)) details.removeAttribute('open');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && details.open) details.removeAttribute('open');
  });

})();